import { selectBasketIsEmpty } from 'containers/OrderDetails/basketSlice'
import Registration from 'containers/forms/Registration'
import SocialBtn from 'components/buttons/SocialBtn'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import { checkIsSmallScreen } from 'utils/screen'
import { useHistory } from 'react-router-dom'
import * as nativeApp from 'utils/nativeApp'
import Popup from 'components/popups/Popup'
import { useSelector } from 'react-redux'
import { selectConfig } from 'appSlice'
import { useState } from 'react'
import Form from './Form'

const LOGIN_TYPES = {
  init: 'init',
  login: 'login',
  registration: 'registration'
}

const LoginPopup = () => {
  const config = useSelector(selectConfig)
  const isBasketEmpty = useSelector(selectBasketIsEmpty)
  const [type, setType] = useState(LOGIN_TYPES.init)

  const { replace } = useHistory()
  const { t } = useTranslation('form')
  const callback = (payload) => {
    if (payload) {
      replace(
        isBasketEmpty
          ? '/dashboard'
          : payload?.hasDataForContract ? '/contract' : '/order/billing'
      )
    }
  }

  return (
    <Popup>
      {type === LOGIN_TYPES.registration
        ? <Registration
          className='registration__popup'
          callback={callback}
          goToLoginForm={() => {
            setType(LOGIN_TYPES.login)
          }}
        />
        : type === LOGIN_TYPES.login
          ? <div className='login__popup login'>
            <div className='popup__title'>
              <div>{t('logIn')}</div>
            </div>

            <div className='login__main'>
              <Form
                callback={callback}
              />
              <div className='login__register'>
                <hr />
                <p>{t('doNotHaveAnAccount')}</p>
                <p
                  className='--secFont'
                  onClick={() => {
                    if (checkIsSmallScreen()) {
                      setType(LOGIN_TYPES.registration)
                    } else {
                      replace('/registration')
                    }
                  }}>
                  {t('signUp')}
                </p>
                <hr />
              </div>

              {(config?.oauth?.apple || config?.oauth?.google) && <div className='login__options'>
                {config?.oauth?.apple && <SocialBtn
                  type='apple'
                  onClick={() => {
                    if (nativeApp.checkIsNativeApp()) {
                      nativeApp.openAuth(config.oauth.apple)
                    } else {
                      window.open(config.oauth.apple, '_self')
                    }
                  }} />}
                {config?.oauth?.google && <SocialBtn
                  type='google'
                  onClick={() => {
                    if (nativeApp.checkIsNativeApp()) {
                      nativeApp.openAuth(config.oauth.google)
                    } else {
                      window.open(config.oauth.google, '_self')
                    }
                  }} />}
              </div>}
            </div>
          </div>
          : <div className='login__popup login'>
            <div className='popup__title'>
              <div>{t('alreadyHaveAccount')}</div>
            </div>

            <div className='login__main init'>
              <div className='login__text --secondary'>{t('loginRequiredToRentOnline')}</div>
              <div>
                <ArrowBtn
                  enlarged
                  showArrow={false}
                  text={t('createAccount')}
                  action={() => {
                    if (checkIsSmallScreen()) {
                      setType(LOGIN_TYPES.registration)
                    } else {
                      replace('/registration')
                    }
                  }} />
                <ArrowBtn
                  enlarged
                  showArrow={false}
                  text={t('logIn')}
                  className='--black'
                  action={() => {
                    setType(LOGIN_TYPES.login)
                  }} />
              </div>

              {(config?.oauth?.apple || config?.oauth?.google) && <>
                <div className='login__or'>
                  <hr />
                  <span>{t('or')}</span>
                  <hr />
                </div>

                <div>
                  {config?.oauth?.apple && <SocialBtn
                    type='apple'
                    onClick={() => {
                      if (nativeApp.checkIsNativeApp()) {
                        nativeApp.openAuth(config.oauth.apple)
                      } else {
                        window.open(config.oauth.apple, '_self')
                      }
                    }} />}
                  {config?.oauth?.google && <SocialBtn
                    type='google'
                    onClick={() => {
                      if (nativeApp.checkIsNativeApp()) {
                        nativeApp.openAuth(config.oauth.google)
                      } else {
                        window.open(config.oauth.google, '_self')
                      }
                    }} />}
                </div>
              </>}
            </div>
          </div>}
    </Popup>
  )
}

export default LoginPopup